import { getField, updateField } from 'vuex-map-fields'
import { authHeader } from '@/services/auth'
import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'
import { filtersGetState } from '@/services/posts'
import moment from 'moment'
import store from '@/store'
import axios from 'axios'

const getDefaultFilter = () => ({
  page: 1,
  offset: 0,
  limit: 10,
  sort: '-DC',
  advanced: false, // Panneau recherche avancé ouvert
  search: '', // Recherche
  type: null, // Type de logement
  sellType: null, // Vente | Location
  published: null, // Visibles / désactivées
  priceGt: 0,
  priceLt: null,
  dateCreationGt: null,
  dateCreationLt: null,
  objectTypes: [],
  withoutPictures: null,
  annoncesDesactivees: null,
  annoncesModeles: null,
  millesime: null,
  modele: null,
  marque: null,
  stock: null,
  identifierCode: null,
  identifierValue: null,
  contact: ''
})

const getPresetFilters = () => ({
  preset: 'enable'
})

export default {
  namespaced: true,
  state: {
    loadingStatus: false,
    post: { code_postal_reel: 30 }, // dans le cas ou l'on crée ou édit une annonce
    tabs: [],
    filter: getDefaultFilter(),
    results: { total: -1, list: [] }, // Stockage des derniers résultats pour accélérer le retour arrière
    modalDelete: false,
    modalDuplicate: false,
    modalUseModel: false,
    titreModalConfirmedDeleteList: 'Etes-vous sûr de vouloir supprimer votre annonce ?',
    modalShowModels: false,
    currentId: null,
    modalConfirmedDeleteList: false,
    selection: [],
    annonceFlux: false,
    saisieEnLigne: false,
    modalConfirmedChangeContactList: false,
    listContacts: []
  },
  getters: {
    getPostField (state) {
      return getField(state.post)
    },
    getResults (state) {
      return state.results
    },
    getPage (state) {
      return state.filter.page
    },
    getLimit (state) {
      return state.filter.limit
    },
    getFilters (state) {
      return state.filter
    },
    getSearch (state) {
      return state.filter.search
    },
    getMarque (state) {
      return state.filter.marque
    },
    getModele (state) {
      return state.filter.modele
    },
    getMillesime (state) {
      return state.filter.millesime
    },
    getDateCreationLt (state) {
      return state.filter.dateCreationLt
    },
    getDateCreationGt (state) {
      return state.filter.dateCreationGt
    },
    getPriceLt (state) {
      return state.filter.priceLt
    },
    getSort (state) {
      return state.filter.sort
    },
    getPriceGt (state) {
      return state.filter.priceGt
    },
    getCurrentId (state) {
      return state.currentId
    },
    getAnnonceFlux (state) {
      return state.annonceFlux
    },
    getSaisieEnLigne (state) {
      return state.saisieEnLigne
    },
    getLoadingStatus (state) {
      return state.loadingStatus
    },
    getStock (state) {
      return state.filter.stock
    },
    getModalUseModel (state) {
      return state.modalUseModel
    },
    getModalDelete (state) {
      return state.modalDelete
    },
    getModalDuplicate (state) {
      return state.modalDuplicate
    },
    getModalShowModels (state) {
      return state.modalShowModels
    },
    getTitreModalConfirmedDeleteList (state) {
      return state.titreModalConfirmedDeleteList
    },
    getModalConfirmedDeleteList (state) {
      return state.modalConfirmedDeleteList
    },
    getSelection (state) {
      return state.selection
    },
    getModalConfirmedChangeContactList (state) {
      return state.modalConfirmedChangeContactList
    },
    getIdentifierCode (state) {
      return state.filter.identifierCode
    },
    getIdentifierValue (state) {
      return state.filter.identifierValue
    },
    getContact (state) {
      return state.filter.contact
    },
    getListContacts: (state) => state.listContacts
  },
  mutations: {
    updatePostField (state, field) {
      updateField(state.post, field)
    },
    setPost (state, post) {
      state.post = post
    },
    setTabs (state, tabs) {
      state.tabs = tabs
    },
    setCurrentId (state, currentId) {
      state.currentId = currentId
    },
    setStock (state, stock) {
      state.filter.stock = stock
    },
    setSelection (state, selection) {
      state.selection = selection
    },
    setLoadingStatus (state, loadingStatus) {
      state.loadingStatus = loadingStatus
    },
    setAnnonceFlux (state, annonceFlux) {
      state.annonceFlux = annonceFlux
    },
    setSaisieEnLigne (state, saisieEnLigne) {
      state.saisieEnLigne = saisieEnLigne
    },
    setModalConfirmedChangeContactList (state, modalConfirmedChangeContactList) {
      state.modalConfirmedChangeContactList = modalConfirmedChangeContactList
    },
    setObjectType (state, objectType) {
      state.post.typeObjet = objectType
    },
    setOfferType (state, offerType) {
      state.post.typeOffre = offerType
    },
    setPage (state, page) {
      state.filter = { ...state.filter, page }
    },
    setLimit (state, limit) {
      state.filter = { ...state.filter, limit, page: 1 }
    },
    setOffset (state, offset) {
      state.filter = { ...state.filter, offset, page: 1 }
    },
    setSort (state, sort) {
      state.filter = { ...state.filter, sort, page: 1 }
    },
    setSearch (state, search) {
      state.filter = { ...state.filter, search, page: 1 }
    },
    setContact (state, contact) {
      state.filter = { ...state.filter, contact, page: 1 }
    },
    setIdentifierCode (state, identifierCode) {
      state.filter = { ...state.filter, identifierCode, page: 1 }
    },
    setIdentifierValue (state, identifierValue) {
      state.filter = { ...state.filter, identifierValue, page: 1 }
    },
    addFilter (state, filter) {
      // Fusionner les filtres
      state.filter = { ...state.filter, ...filter, page: 1 }
      
      // Supprimer les clés marquées comme undefined (pour nettoyer les filtres désépinglés)
      Object.keys(state.filter).forEach(key => {
        if (state.filter[key] === undefined) {
          delete state.filter[key]
        }
      })
    },
    replaceFilter (state, filter) {
      // Remplacer complètement le filtre sans getDefaultFilter()
      // Garder les champs système
      state.filter = {
        page: state.filter.page || 1,
        offset: state.filter.offset || 0,
        limit: state.filter.limit || 10,
        sort: state.filter.sort || '-DC',
        advanced: state.filter.advanced || false,
        ...filter
      }
    },
    setFilter (state, filter) {
      state.filter = {
        ...getDefaultFilter(),
        advanced: state.filter.advanced,
        ...filter
      }
    },
    setFilters (state, { key, value }) {
      state.filter[key] = value
    },
    resetFilter (state) {
      state.filter = getDefaultFilter()
      state.results = { total: -1, list: [] }
    },
    resetPresetFilters (state) {
      state.filter = {
        ...getDefaultFilter(),
        advanced: state.filter.advanced,
        ...getPresetFilters()
      }
    },
    fetchModels (state) {
      state.filter = getDefaultFilter()
      state.filter.annoncesModeles = true
      state.modalShowModels = true
    },
    setResults (state, results) {
      state.results = results
    },
    setModalUseModel (state, modalUseModel) {
      state.modalUseModel = modalUseModel
    },
    setModalDelete (state, modalDelete) {
      state.modalDelete = modalDelete
    },
    setModalDuplicate (state, modalDuplicate) {
      state.modalDuplicate = modalDuplicate
    },
    setModalShowModels (state, modalShowModels) {
      state.modalShowModels = modalShowModels
    },
    setModalConfirmedDeleteList (state, modalConfirmedDeleteList) {
      state.modalConfirmedDeleteList = modalConfirmedDeleteList
    },
    setTitreModalConfirmedDeleteList (state, quantite) {
      if (quantite === 1) {
        state.titreModalConfirmedDeleteList = 'Etes-vous sûr de vouloir supprimer votre annonce ?'
      } else {
        state.titreModalConfirmedDeleteList = 'Etes-vous sûr de vouloir supprimer vos ' + quantite + ' annonces ?'
      }
    },
    setListContacts (state, list) {
      state.listContacts = list
    }
  },
  actions: {
    loadModels (context, payload) {
      context.commit('fetchModels')
      context.dispatch('loadPosts')
    },
    loadPosts ({ commit, getters }, options = {}) {
      const { silent = false } = options
      
      // Ne pas afficher le loader si silent (pour les cascaders)
      if (!silent) {
        commit('setLoadingStatus', true)
      }
      const user = store.getters.getUser

      let url = '/annonce?champsRechercheLibre[]=ville&champsRechercheLibre[]=titre&champsRechercheLibre[]=reference'
      url = url + '&page=' + getters.getPage
      url = url + '&perPage=' + getters.getLimit
      url = url + '&rechercheLibre=' + getters.getSearch
      if (getters.getStock) {
        url = url + '&stock=' + getters.getStock
      }
      if (getters.getMarque) {
        url = url + '&marque=' + getters.getMarque
      }
      if (getters.getModele) {
        url = url + '&modele=' + getters.getModele
      }
      if (getters.getMillesime) {
        url = url + '&millesime=' + getters.getMillesime
      }
      if (getters.getPriceGt) {
        url = url + '&prixGt=' + getters.getPriceGt
      }
      if (getters.getPriceLt) {
        url = url + '&prixLt=' + getters.getPriceLt
      }
      if (getters.getSort) {
        url = url + '&orderBy=' + getters.getSort
      }
      if (getters.getDateCreationGt) {
        const startDate = moment(getters.getDateCreationGt).format('DD/MM/YYYY')
        url = url + '&dateCreationGt=' + startDate
      }
      if (getters.getDateCreationLt) {
        if (getters.getDateCreationLt != null) {
          const endDate = moment(getters.getDateCreationLt).add(1, 'd')
          url = url + '&dateCreationLt=' + moment(endDate).format('DD/MM/YYYY')
        }
      }
      // Gérer l'état des annonces via le preset ou les filtres individuels
      const etat = filtersGetState(getters.getFilters)
      url = url + '&etat=' + etat
      
      // Gérer les photos
      if (getters.getFilters.withoutPictures || getters.getFilters.preset === 'withoutPictures') {
        url = url + '&sansPhoto=' + 'O'
      }
      
      if (getters.getFilters.contact !== '') {
        url = url + '&dataValues[CONTACT_A_AFFICHER]=' + getters.getFilters.contact
      }
      // Ne pas appliquer le filtre utilisateur pour :
      // - les annonces modèles
      // - la bibliothèque de contenus (partagée)
      const isModelesPreset = getters.getFilters.preset === 'modeles' || getters.getFilters.annoncesModeles === true
      const isContentLibrary = getters.getFilters.isContentLibrary === true
      if (store.getters.isSubUser && Object.prototype.hasOwnProperty.call(user, 'identifierCode') && Object.prototype.hasOwnProperty.call(user, 'identifierValue') && !isModelesPreset && !isContentLibrary) {
        url = url + '&dataValues[USER_DATA_CODE]=' + user.identifierCode
        url = url + '&dataValues[USER_DATA_VALUE]=' + user.identifierValue
      }
      if (getters.getFilters.annoncesDiffusees) {
        url = url + '&annoncesDiffusees=' + getters.getFilters.annoncesDiffusees
      }

      return HTTP_HYPER_ESPACE_BACKEND.get(url)
        .then(response => {
          if (response.data._embedded.annonce) {
            const objResponse = {
              total: response.data.total_items,
              list: response.data._embedded.annonce
            }
            commit('setResults', objResponse)
            commit('setLoadingStatus', false)
            if (getters.getResults.list.find(element => element.sourceCode === 'SAISIE_VO')) {
              commit('setSaisieEnLigne', true)
            } else {
              commit('setSaisieEnLigne', false)
            }
            // On regarde si au moins une annonce vient du flux
            if (getters.getResults.list.find(element => element.sourceCode !== 'SAISIE_VO')) {
              commit('setAnnonceFlux', true)
            } else {
              commit('setAnnonceFlux', false)
            }
          }
        }).catch(error => {
          console.log({ type: 'error', message: error })
          commit('setLoadingStatus', false)
        })
    },
    loadContacts ({ commit }) {
      const params = {
        headers: authHeader()
      }
      return HTTP_HYPER_ESPACE_BACKEND.get('/users', params)
        .then(response => {
          commit('setListContacts', response.data)
        })
        .catch(error => {
          return { type: 'error', message: error }
        })
    }
  }
}
